import { Box } from "@chakra-ui/react";
import _ from "lodash";
import { useSelector } from "react-redux";
import FilterForm from "../../components/FilterForm";
import TicketsByBranchReport from "../../components/organization/reports/TicketsByBranch";
import Loader from "../../components/loader";
import { getReportDescription } from "../../store/helpers";

const TicketsPerBranch = ({ showFilterForm = true, reportIndex = 1 }) => {
  const { branches, tickets, organizationId, loading, reportRange, branchId } =
    useSelector((state) => state.defaultReducer);
  const branchesClone = _.cloneDeep(branches);
  const ticketsClone = _.cloneDeep(tickets);

  const orgBranches = branchesClone
    .filter(
      (branch) =>
        branch.organizationId === organizationId && Number(branch.reportStatus)
    )
    .filter((a) => !branchId.length || (branchId.length && a.id === branchId));

  const branchesMap = orgBranches.reduce((acc, branch) => {
    acc[branch.id] = [];
    return acc;
  }, {});

  ticketsClone.forEach((data) => {
    const branchId = data.branchId;

    if (Array.isArray(branchesMap[branchId])) {
      branchesMap[branchId].push(data);
    }
  });
  const title = `${reportIndex}. Tickets Per Branch`;
  console.log(title);

  return (
    <Box>
      {showFilterForm ? <FilterForm /> : <></>}
      {loading ? (
        <>
          <Loader />
        </>
      ) : (
        <>
          {" "}
          {tickets.length ? (
            <>
              <h1>{title}</h1>
              <p>{getReportDescription(reportRange).TicketsByBranch}</p>

              <TicketsByBranchReport
                branchesMap={branchesMap}
                reportIndex={reportIndex}
              />
            </>
          ) : (
            <Box mt={10}>
              <p>No data available in this search</p>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default TicketsPerBranch;
